var map = {
	"./1.png": 9145,
	"./2.png": 988,
	"./3.png": 3944,
	"./4.png": 890,
	"./5.png": 5169,
	"./6.png": 535,
	"./7.png": 4807,
	"./8.png": 4811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2812;